import React from 'react';
import PropTypes from 'prop-types';

const ThreatIcon = ({ width = 32, height = 32, color = '#11AEFB' }) => (
  <svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.75 7.44318C23.75 9.65909 21.5 16.3068 21.5 16.3068H18.5C18.5 16.3068 16.25 9.65909 16.25 7.44318C16.25 5.40455 17.93 3.75 20 3.75C22.07 3.75 23.75 5.40455 23.75 7.44318ZM20 18.5227C18.35 18.5227 17 19.8523 17 21.4773C17 23.1023 18.35 24.4318 20 24.4318C21.65 24.4318 23 23.1023 23 21.4773C23 19.8523 21.65 18.5227 20 18.5227ZM26.12 11.2989C26.39 10.1909 26.615 9.12727 26.705 8.25568C31.625 10.6784 35 15.6864 35 21.4773C35 29.6318 28.28 36.25 20 36.25C11.72 36.25 5 29.6318 5 21.4773C5 15.6864 8.375 10.6784 13.295 8.25568C13.4 9.12727 13.61 10.2057 13.88 11.2989C10.37 13.367 8 17.1489 8 21.4773C8 28.0068 13.37 33.2955 20 33.2955C26.63 33.2955 32 28.0068 32 21.4773C32 17.1489 29.63 13.367 26.12 11.2989ZM29 21.4773C29 26.367 24.965 30.3409 20 30.3409C15.035 30.3409 11 26.367 11 21.4773C11 18.5227 12.47 15.908 14.72 14.2977C15.065 15.4943 15.695 17.3557 15.695 17.3557C14.645 18.4193 14 19.8818 14 21.4773C14 24.742 16.685 27.3864 20 27.3864C23.315 27.3864 26 24.742 26 21.4773C26 19.8818 25.355 18.4193 24.305 17.3557C24.305 17.3557 24.92 15.5534 25.28 14.2977C27.53 15.908 29 18.5227 29 21.4773Z"
      fill={color}
    />
  </svg>
);

ThreatIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

export default ThreatIcon;
